import React from 'react';
import { createRoot } from 'react-dom/client';   // ✅ جایگزین ReactDOM
import './i18n';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider, useSelector } from 'react-redux';
import { configureStore } from './redux/store';

import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ConfigProvider } from 'antd';
import { theme as antdTheme } from 'antd';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      cacheTime: 30000, // 30 ثانیه
    },
  },
});

const container:any = document.getElementById('root');
const root = createRoot(container);

const Root = () => {
  const themeMode = useSelector((state: any) => state.theme);

  return (
    <ConfigProvider
      theme={{
        algorithm:
          themeMode === 'dark'
            ? antdTheme.darkAlgorithm
            : antdTheme.defaultAlgorithm,
        token: {
          colorPrimary: '#27ae60',
        },
      }}
    >
      <App />
    </ConfigProvider>
  );
};

root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={configureStore({})}>
      <Root />
      <ReactQueryDevtools />
    </Provider>
  </QueryClientProvider>
);

// اگر خواستی لاگ Performance بگیری
reportWebVitals();
